/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StatsOperationImpactedDatasetsQueryCriteriaDto = {
    customMetadataEntries?: Array<string>;
    dataProducts?: Array<string>;
    domains: Array<string>;
    historyDays?: number;
    owners?: Array<string>;
    sortField: StatsOperationImpactedDatasetsQueryCriteriaDto.sortField;
    sources?: Array<string>;
    tags?: Array<string>;
};

export namespace StatsOperationImpactedDatasetsQueryCriteriaDto {

    export enum sortField {
        USAGE = 'USAGE',
        INCIDENT_COUNT = 'INCIDENT_COUNT',
    }


}
